var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M304 144C304 64.471 239.531 0 160 0S16 64.471 16 144C16 220.898 76.438 283.154 152.32 287.227C152.289 287.52 152 287.699 152 288V504C152 508.406 155.594 512 160 512S168 508.406 168 504V288C168 287.699 167.711 287.52 167.68 287.227C243.562 283.154 304 220.898 304 144ZM160 272C89.422 272 32 214.578 32 144C32 73.42 89.422 16 160 16S288 73.42 288 144C288 214.578 230.578 272 160 272ZM160 48C107.062 48 64 91.062 64 144C64 148.406 67.594 152 72 152S80 148.406 80 144C80 99.875 115.875 64 160 64C164.406 64 168 60.406 168 56S164.406 48 160 48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.2d828c61c5950e25bfb9b427d9fec004.svg";
export { ForwardRef as ReactComponent };